// @ts-nocheck

import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { useScript } from '../../hooks';
import { getLang } from '../../i18n/l10n';

const URL = 'https://widgets.sir.sportradar.com/c1d88151bb6140ccf96759f133dba02f/widgetloader';

const SportRadar = styled.div``;

type widgetOptionsType = {
  srTournamentId?: number;
  seasonId?: number;
};

type PropsType = {
  className?: string;
  displayWidget: boolean;
  commandKey: string;
  options: widgetOptionsType;
};

const SportRadarWidget = ({ className, displayWidget, commandKey, options }: PropsType) => {
  const trackerDomNodeRef = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const [loaded, error] = useScript(URL);

  if (!window.SIR) {
    window.SIR = { o: { language: getLang(), theme: false } };
  }

  useEffect(() => {
    if (loaded && !error && !isReady) {
      const interval = setInterval(() => {
        if (typeof window.SIR === 'function') {
          setIsReady(true);
        }
      }, 50);
      return () => clearInterval(interval);
    }
  }, [loaded, error, isReady]);

  useEffect(() => {
    if (window.SIR && isReady) {
      const currentTrackerDomNodeRef = trackerDomNodeRef.current;
      if (displayWidget) {
        window.SIR('addWidget', currentTrackerDomNodeRef, commandKey, {
          ...options,
        });
      } else {
        window.SIR('removeWidget', currentTrackerDomNodeRef);
      }
    }
  }, [commandKey, displayWidget, options, isReady]);

  return <SportRadar className={className} ref={trackerDomNodeRef} />;
};

export default SportRadarWidget;
